import React from 'react';

const DeleteEntityModalContent = ({entity}) => {
  return (
    <h5 className="mb-4">Are you sure you want to delete this {entity}?</h5>
  )
}

export default DeleteEntityModalContent;